import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ChevronLeft = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 30.144531 11.394531 C 30.753906 10.785156 31.746094 10.785156 32.355469 11.394531 C 32.964844 12.003906 32.964844 12.996094 32.355469 13.605469 L 20.960938 25 L 32.355469 36.394531 L 32.460938 36.511719 C 32.964844 37.125 32.925781 38.03125 32.355469 38.605469 C 31.78125 39.175781 30.875 39.214844 30.261719 38.710938 L 30.144531 38.605469 L 17.644531 26.105469 C 17.035156 25.496094 17.035156 24.503906 17.644531 23.894531 Z M 30.144531 11.394531 "
        fill={color}
      />
    </svg>
  )
}
